import { Handler, IframeSelectionPayload } from "../common/types";
import { IframeActions, MsgBusActions } from "../common/events";
import { logger } from "../services/logger";
import { WIDGET_METADATA } from "../common/config";
import {
  getPopularBetBuilderBetListName,
  getPopularBetBuilderEventCategory,
  getAccaBetListName,
  getAccaTrackingEvent,
} from "../common/utils";
import { track } from "@sb/analytics";

export const addToSlip: Handler<IframeSelectionPayload> = async (
  payload,
  { iframe, msgBus, gtpService, stateMngr },
) => {
  logger.log(`[From Iframe]: Add to Betslip: `, payload);

  try {
    const widgetType = iframe.getWidgetType();
    const metadata = WIDGET_METADATA[widgetType];

    if (metadata.requiresGtpMapping) {
      track({
        EventName: "popular_BetBuilder_add",
        EventAction: "Add to Betslip",
        EventLabel: payload.analytics.accaName,
        EventCategory: getPopularBetBuilderEventCategory(),
        BetListName: [getPopularBetBuilderBetListName()],
      });
      iframe.publish(IframeActions.UPDATE_BETSLIP, payload);
      logger.log(`[To Iframe]: ${IframeActions.UPDATE_BETSLIP}: `, payload);
      const gtpRes = await gtpService.getBetSlipMapping(payload);
      const response = stateMngr.handleAddToBetslip(payload, gtpRes.mappings);
      msgBus.publish(MsgBusActions.ADD_TO_SLIP_BB, response);
      logger.log(`[To MsgBus]: ${MsgBusActions.ADD_TO_SLIP_BB}: `, response);
    } else {
      const accaPayload = payload as any;
      track({
        EventName: getAccaTrackingEvent(widgetType, "add"),
        EventAction: "Add to Betslip",
        EventLabel: accaPayload.analytics?.accaName,
        BetListName: [getAccaBetListName(widgetType)],
      });
      const selectionsForSlip = {
        allBetIds: accaPayload.selections.map((item: any) => ({
          id: item.selectionId.replace("OB_OU", ""),
          priceType: "FIXED_ODDS",
          analytics: accaPayload.analytics,
        })),
      };
      iframe.publish(IframeActions.UPDATE_BETSLIP_ACCA, payload);
      logger.log(`[To Iframe]: ${IframeActions.UPDATE_BETSLIP_ACCA}: `, payload);
      msgBus.publish(MsgBusActions.ADD_TO_SLIP, selectionsForSlip);
      logger.log(`[To MsgBus]: ${MsgBusActions.ADD_TO_SLIP}: `, selectionsForSlip);
    }
  } catch (err) {
    console.error(err);
  }
};
